import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/takeUntil';
import { OffboardingCreate, OffboardingEntry } from '../../models/offboarding.model';
import { OffboardingService } from '../../services/offboarding.service';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey, assetOperationId } from '../common/employee-assets/asset.helpers';
import { OFFBOARDING as O } from './offboarding.constants';

@Component({selector: 'app-offboarding-create', templateUrl: './offboarding-create.component.html',
  styleUrls: ['../common/employee-assets/asset-form.component.css', '../common/employee-assets/employee-assets.component.css']})
export class OffboardingCreateComponent implements OnInit, OnDestroy {
  draft: OffboardingCreate;
  permissions: OffboardingEntry;
  errorKey = ASSET.empty;
  busy = false;
  private submittedContent = ASSET.empty;
  private contextRequest: Subscription;
  private createRequest: Subscription;
  private destroyed = new Subject<void>();
  constructor(private api: OffboardingService, private route: ActivatedRoute, private router: Router) {}
  ngOnInit(): void {
    this.route.params.takeUntil(this.destroyed).subscribe(params => this.openEmployee(params[O.employeeId] || this.route.snapshot.params[O.employeeId]));
  }
  private openEmployee(employeeId: string): void {
    if (this.draft && this.draft.employeeId === employeeId) { return; }
    if (this.createRequest) { this.createRequest.unsubscribe(); }
    this.busy = false; this.submittedContent = ASSET.empty;
    this.draft = {operationId: assetOperationId(), employeeId: employeeId,
      employmentDate: ASSET.empty, terminationDate: ASSET.empty,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || O.defaultZone};
    this.loadContext();
  }
  loadContext(): void {
    if (this.contextRequest) { this.contextRequest.unsubscribe(); }
    const employeeId = this.draft.employeeId;
    this.errorKey = ASSET.empty; this.permissions = null;
    this.draft.employmentDate = ASSET.empty;
    this.contextRequest = this.api.entry(employeeId).takeUntil(this.destroyed).subscribe(entry => {
        if (this.draft.employeeId !== employeeId) { return; }
        this.permissions = entry;
        this.draft.employmentDate = entry.employmentDate || ASSET.empty;
        if (entry.canStart && !this.draft.employmentDate) { this.errorKey = O.employmentMissing; }
      }, error => this.errorKey = assetErrorKey(error, false));
  }
  ngOnDestroy(): void { this.destroyed.next(); this.destroyed.complete(); }
  submit(): void {
    if (this.busy || !this.draft.terminationDate || !this.permissions || !this.permissions.canStart || !this.draft.employmentDate) { return; }
    this.prepareOperation();
    this.busy = true; this.errorKey = ASSET.empty;
    const employeeId = this.draft.employeeId;
    this.createRequest = this.api.create(this.draft).takeUntil(this.destroyed).subscribe(result => {
      if (this.draft.employeeId !== employeeId) { return; }
      this.router.navigate([O.route, result.id]);
    }, error => { this.busy = false; this.errorKey = assetErrorKey(error, true); });
  }
  private prepareOperation(): void {
    const content = JSON.stringify([this.draft.employeeId, this.draft.employmentDate, this.draft.terminationDate]);
    if (this.submittedContent && this.submittedContent !== content) { this.draft.operationId = assetOperationId(); }
    this.submittedContent = content;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-create.component.ts